export enum BUTTON_TYPES {
  NORMAL = 'NORMAL',
  WIDE = 'WIDE',
  INVERTED = 'INVERTED',
  INVERTED_WIDE = 'INVERTED_WIDE'
}

export enum FORM_CHOICE_TYPES {
  RABBIT = 'RABBIT',
  DOG = 'DOG',
  CAT = 'CAT',
  HORSE = 'HORSE',
  DUCK = 'DUCK',
  GUINEA_PIG = 'GUINEA_PIG',
  ALL_PET_TYPES = 'ALL_PET_TYPES',
  GENDER = 'GENDER',
  NEUTRED = 'NEUTRED',
  ADD_PET = 'ADD_PET',
  RECURRENCE = 'RECURRENCE'
}

export const FORM_CHOICE_COMPONENT_TYPES = {
  ALL_PET_TYPES: {
    title: `What is the type of your pet?`,
    options: [
      { option: 'Dog', value: 'DOG', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'Cat', value: 'CAT', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'Rabbit', value: 'RABBIT', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'Horse', value: 'HORSE', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'Duck', value: 'DUCK', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'Guinea Pig', value: 'GUINEA_PIG', buttonType: BUTTON_TYPES.NORMAL }
    ],
    registerAs: 'TYPE'
  },
  DOG: {
    title: `What is the type of your pet?`,
    options: [{ option: 'Dog', value: 'DOG', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  CAT: {
    title: `What is the type of your pet?`,
    options: [{ option: 'Cat', value: 'CAT', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  RABBIT: {
    title: `What is the type of your pet?`,
    options: [{ option: 'Rabbit', value: 'RABBIT', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  HORSE: {
    title: `What is the type of your pet?`,
    options: [{ option: 'Horse', value: 'HORSE', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  DUCK: {
    title: `What is the type of your pet?`,
    options: [{ option: 'Duck', value: 'DUCK', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  GUINEA_PIG: {
    title: `What is the type of your pet?`,
    options: [{ option: 'Guinea Pig', value: 'GUINEA_PIG', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  GENDER: {
    title: `What’s {{petName}}'s Gender?`,
    options: [
      { option: 'Male', value: 'MALE', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'Female', value: 'FEMALE', buttonType: BUTTON_TYPES.NORMAL }
    ],
    registerAs: 'GENDER'
  },
  NEUTRED: {
    title: `Is {{petName}} {{petNeutred}}?`,
    options: [
      { option: 'Yes', value: 'true', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'No', value: 'false', buttonType: BUTTON_TYPES.NORMAL }
    ],
    registerAs: 'NEUTRED'
  },
  ADD_PET: {
    title: `{{petName}}'s profile is created and saved.`,
    options: [
      {
        option: 'Add another pet',
        value: 'true',
        buttonType: BUTTON_TYPES.WIDE
      },
      {
        option: 'Continue with booking',
        value: 'false',
        buttonType: BUTTON_TYPES.INVERTED_WIDE
      }
    ],
    registerAs: 'ADD_PET'
  },
  RECURRENCE: {
    title: `What type of booking?`,
    options: [
      {
        option: 'One-off',
        value: 'one_off',
        buttonType: BUTTON_TYPES.WIDE
      },
      {
        option: 'Repeated',
        value: 'recurring',
        buttonType: BUTTON_TYPES.WIDE
      }
    ],
    registerAs: 'RECURRENCE'
  }
} as const;
